var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 51.2143H48V47.1965H42.6667V28.4464H37.9167L31.75 34.1803L34.9584 37.5285C35.9583 36.6496 36.5834 36.1892 37.25 35.1429H37.3334V47.1965H32V51.2143H32ZM53.3334 40.5C53.3334 48.1172 48.75 57.9107 40 57.9107C31.25 57.9107 26.6667 48.1172 26.6667 40.5C26.6667 32.8828 31.25 23.0893 40 23.0893C48.75 23.0893 53.3334 32.8828 53.3334 40.5ZM74.6667 51.2143V29.7858C68.7917 29.7858 64 24.9727 64 19.0714H15.9999C15.9999 24.9726 11.2083 29.7858 5.33326 29.7858V51.2143C11.2082 51.2143 15.9999 56.0273 15.9999 61.9286H64C64 56.0274 68.7916 51.2143 74.6667 51.2143ZM80 16.3928V64.6071C80 66.072 78.7917 67.2857 77.3334 67.2857H2.6667C1.20836 67.2857 6.10352e-05 66.072 6.10352e-05 64.6071V16.3928C6.10352e-05 14.928 1.20836 13.7143 2.6667 13.7143H77.3334C78.7917 13.7143 80 14.928 80 16.3928Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.fa71503154fcbb88fa2a56092e9eaf79.svg";
export { ForwardRef as ReactComponent };